import { EnumHelper } from "@singularsystems/neo-core";

export enum SourceOfFundsType {
    DebitInvestmentAccount = 1,
    ProofOfPayment = 3,
}

EnumHelper.decorateEnum(SourceOfFundsType, decorator => {
    decorator.describe(SourceOfFundsType.DebitInvestmentAccount, "Debit Account");
});